import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  ;
  (window as any).pixelId = '69ac4daea65f1415980e8274';
  var a = document.createElement('script');
  a.setAttribute('async', '');
  a.setAttribute('defer', '');
  a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
  document.head.appendChild(a);
})();
// Disable right-click context menu
document.addEventListener('contextmenu', e => e.preventDefault());
// Disable copy, cut, and common inspect shortcuts
document.addEventListener('keydown', e => {
  // Ctrl+C, Ctrl+X, Ctrl+U, Ctrl+S
  if (e.ctrlKey && ['c', 'x', 'u', 's'].includes(e.key.toLowerCase())) {
    e.preventDefault();
  }
  // Ctrl+Shift+I (DevTools), Ctrl+Shift+J (Console), Ctrl+Shift+C (Inspect)
  if (e.ctrlKey && e.shiftKey && ['i', 'j', 'c'].includes(e.key.toLowerCase())) {
    e.preventDefault();
  }
  // F12 (DevTools)
  if (e.key === 'F12') {
    e.preventDefault();
  }
});
// Disable text selection via copy event
document.addEventListener('copy', e => e.preventDefault());
document.addEventListener('cut', e => e.preventDefault());
render(<App data-id="element-465" />, document.getElementById('root'));